export default "__VITE_ASSET__ClmvYHBf__"